 export function initAccordion() {

const items = document.querySelectorAll<HTMLElement>("#accordion .item .headerQuestions");

items.forEach((item) => {
  item.addEventListener("click", (e: MouseEvent) => {
    const target = e.currentTarget as HTMLElement;
    const currentItem = target.closest(".item") as HTMLElement;
    const wasActive = currentItem.classList.contains("active");

    items.forEach((header) =>
      header.closest(".item")?.classList.remove("active")
    );

    if (!wasActive) currentItem.classList.add("active");
  });
});

 }